import type { AppVersion } from '@/types'

/**
 * 主包响应经常缺展示信息。只覆盖主包、版本号和子包列表。
 * 没带 platform_packages 时写成空数组，避免上一份主包的子包留下来，
 * 也避免 undefined 被列表合并用 ?? 填回旧数据。
 * 介绍、更新说明、定时发布继续用本地草稿。
 */
export function applyMainUpload(
  local: AppVersion | undefined,
  uploadDraft: AppVersion,
  mainParse: NonNullable<AppVersion['main_package']>,
  versionId: string,
): AppVersion {
  const version: AppVersion = local
    ? { ...local, id: versionId }
    : { ...uploadDraft, id: uploadDraft.id || versionId }
  version.main_package = mainParse
  if (mainParse.version_code) version.version = mainParse.version_code
  if (mainParse.platforms.length) version.platforms = mainParse.platforms
  if (uploadDraft.is_first_version != null) {
    version.is_first_version = uploadDraft.is_first_version
  }
  version.platform_packages = Array.isArray(uploadDraft.platform_packages)
    ? uploadDraft.platform_packages
    : []
  return version
}
